import { MAIN_URL } from './consts';

export default {
  mainURL: MAIN_URL,
  authlocalStorageKey: 'authTokens',

  authCookieKey: '_yuri_bin_done',

  auth: {
    dnevnikRu: {
      link: [MAIN_URL, 'api/dnevnikru/login'].join(''),
      name: 'Dnevnik.ru',
      logo: 'https://static.staging.dnevnik.ru/img/logotypes/logotype.png',
    },
  },
  httpAuthHeader: 'X-INLEARNO-TOKEN',

  notFound: {
    name: 'error-404',
  },

  eventVisitHistory: {
    localStorageKey: 'event-card-history',
    count: 20,
  },

  eventDeferred: {
    localStorageKey: 'event-card-deferred',
  },

  apiModuleNames: {
    PFDOD: 'pfdod',
  },

  errors: {
    default:
      'У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, другие статьи, а позже попробуйте еще раз!',
  },

  organizations: {
    list: {},
    card: {
      programsCount: 4,
    },
  },

  activities: {
    list: {},
    card: {
      programsCount: 4,
    },
  },

  reviews: {
    addImmediately: false,
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js